/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import QuestionOptionVo from './QuestionOptionVo';




  /**
   * The PassageChoiceQuestionVo model module.
   * @module drill/model/PassageChoiceQuestionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PassageChoiceQuestionVo</code>.
   * @alias module:drill/model/PassageChoiceQuestionVo
   * @class
   * @param text {String} 题干
   * @param optionList {Array.<module:drill/model/QuestionOptionVo>} 
   * @param correctAnswer {Array.<String>} 
   */
  var exports = function(text, optionList, correctAnswer) {
    var _this = this;

    _this['text'] = text;


    _this['optionList'] = optionList;
    _this['correctAnswer'] = correctAnswer;

  };

  /**
   * Constructs a <code>PassageChoiceQuestionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/PassageChoiceQuestionVo} obj Optional instance to populate.
   * @return {module:drill/model/PassageChoiceQuestionVo} The populated <code>PassageChoiceQuestionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'explanation')) {
        obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUrl')) {
        obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'optionList')) {
        obj['optionList'] = ApiClient.convertToType(data['optionList'], [QuestionOptionVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'correctAnswer')) {
        obj['correctAnswer'] = ApiClient.convertToType(data['correctAnswer'], ['String']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUri')) {
        obj['imageUri'] = ApiClient.convertToType(data['imageUri'], 'String');
      }
    }
    return obj;
  }

  /**
   * 题干
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 解析
   * @member {String} explanation
   */
  exports.prototype['explanation'] = undefined;
  /**
   * 图片
   * @member {String} imageUrl
   */
  exports.prototype['imageUrl'] = undefined;
  /**
   * @member {Array.<module:drill/model/QuestionOptionVo>} optionList
   */
  exports.prototype['optionList'] = undefined;
  /**
   * @member {Array.<String>} correctAnswer
   */
  exports.prototype['correctAnswer'] = undefined;
  /**
   * 图片
   * @member {String} imageUri
   */
  exports.prototype['imageUri'] = undefined;



  export default exports;
;


